import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============
    GetUserAuthentication(_data_) {
        return axios.post(config.WEB_TOKEN_PATH, _data_, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            crossdomain: true,
        });
    },
    GenerateCaptcha(_data_) {
        return axios.post(config.WEB_API_PATH + 'login/v1/GenerateCaptcha', "", {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token, },
            crossdomain: true,
            params: _data_,
        });
    },
    CreateNewUser(_data_) {
        return axios.post(config.WEB_API_PATH + 'signup/v1/CreateNewUser', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token, },
            crossdomain: true,
        });
    },
    GenerateLoginOTP(_data_) {
        return axios.post(config.WEB_API_PATH + 'login/v1/GenerateLoginOTP', _data_, {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token }
        });
    },
    ResetPasswordOnline(_data_) {
        return axios.post(config.WEB_API_PATH + 'login/v1/ResetPasswordOnline', "", {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            crossdomain: true,
            params: _data_,
        });
    },
    //======================================
    //============== Get API ===============
    getUserType(_data_) {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetUserType', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetTitle() {
        return axios.get(config.WEB_API_PATH + 'AllMaster/v1/GetTitle', "", {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: ""
        });
    },
    GetUserActivation(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/GetUserActivation', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    GetForgetUser(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/GetForgetUser', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    OTPVerification(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/OTPVerification', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    changePassword(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/ChangePassword', {
            headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
            params: _data_
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/loginjs.js